// ===============================================================
// ---------------------------------------------------------------
// Dependencies
import { useEffect, useContext, Fragment, Suspense, lazy } from "react"

// Context
import AppContext from "../../Context/App/appContext"
import AppNavbar from "../Modules/AppNavbar"

// Modules
import Spinner from "../Modules/Spinner"
import Theme from "../Modules/Theme"

// Lazy Modules
const LinkCardShowcase = lazy(() => import("../Modules/LinkCardShowcase"))
const XtraSavingsInfoNew = lazy(() => import("../Modules/XtraSavingsInfoNew"))
const LinkCardTiles = lazy(() => import("../Modules/LinkCardTiles"))
const StuckPeople = lazy(() => import("../Modules/StuckPeople"))
const Footer = lazy(() => import("../Modules/Footer"))
const XtraSavingsFAQ = lazy(() => import("../Modules/XtraSavingsFAQ"))


// ===============================================================
const LinkCard = () => {
	// ---------------------------------------------------------------
	// Context
	const appContext = useContext(AppContext)
	const { getPeople, people,getFaqs, getAllFaqs } = appContext
	// ---------------------------------------------------------------
	// Get content and scroll to top on load
	useEffect(() => {
		getPeople()
		window.scrollTo(0, 0);
		getFaqs()
		getAllFaqs()
		// eslint-disable-next-line
	}, [])



	return (
		<Fragment>
			<Suspense fallback={<Spinner />}>
				{people ? (
					<Theme id="link-card" className="link-card">
						<AppNavbar />
						<LinkCardShowcase />
						<XtraSavingsInfoNew />
						<LinkCardTiles />
						<XtraSavingsFAQ/>
						<StuckPeople />
						<Footer />
					</Theme>
				) : (
					<Spinner />
				)}
			</Suspense>
		</Fragment>
	)
}

export default LinkCard
